export var EmailPayloadTemplate;
(function (EmailPayloadTemplate) {
    EmailPayloadTemplate["CLIENT_INQUIRY"] = "client-inquiry";
})(EmailPayloadTemplate || (EmailPayloadTemplate = {}));
